import { SnackbarKey, useSnackbar as useNotistack } from 'notistack';

const AUTO_HIDE_MS = 5000;

enum SnackbarVariant {
  Default = 'default',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
interface SnackbarOptions {
  onClose?: () => void;
  variant: SnackbarVariant;
  message: string;
  preventDuplicate?: boolean;
  persist?: boolean;
  key?: SnackbarKey;
}

const useSnackbar = () => {
  const { enqueueSnackbar } = useNotistack();
  return ({
    onClose,
    message,
    variant,
    key,
    preventDuplicate = false,
    persist = false,
  }: SnackbarOptions) => {
    enqueueSnackbar(message, {
      variant,
      autoHideDuration: AUTO_HIDE_MS,
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
      preventDuplicate,
      onClose,
      persist,
      key,
    });
  };
};

export { useSnackbar, SnackbarVariant };
